import React from "react";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Link
} from "@mui/material";

const VideoCard = ({ video }) => {
  return (
    <Card
      sx={{
        backgroundColor: "transparent",
        color: "white",
      }}
    >
      <CardActionArea component={Link} href={`/${video._id}`} onClick={() => console.log('Click')}>
        <CardMedia component="img" height="194" image={video.previewImage} />
        <CardContent>
          <Typography variant="h5" component="h1">
            {video.title}
          </Typography>
          <Typography variant="h6" component="p" color="neutral">
            {video.releaseDate}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default VideoCard;
